import PlacementBackground from './placementBackground.container';

export default PlacementBackground;
